var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"image",style:({ 'background-image': 'url(' + _vm.src + ')' })},[_c('img',{attrs:{"src":"img/4.svg"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }